<template>
  <div>
    <!-- <v-container v-if="header.length > 0">
      <ProposalSlider :proposals="header" />
    </v-container> -->
    <component :is="templateName" :key="key"></component>
    <!-- <v-container v-if="footer.length > 0">
      <ProposalSlider :proposals="footer" />
    </v-container> -->
  </div>
</template>
<style scoped lang="scss"></style>
<script>
import camelCase from "lodash/camelCase";
import split from "lodash/split";

import categoryMain from "@/components/category/CategoryMain";
import categoryMed from "@/components/category/CategoryMed";
import categoryLeaflet from "@/components/category/CategoryLeaflet";
import categoryCustom from "@/components/category/CategoryCustom";
// import ProposalSlider from "@/components/proposal/ProposalSlider";

import categoryMixins from "~/mixins/category";
import deliveryReactive from "~/mixins/deliveryReactive";
import { mapProposal } from "~/service/ebsn.js";

export default {
  name: "Category",
  mixins: [categoryMixins, deliveryReactive],
  components: {
    categoryMain,
    categoryMed,
    categoryLeaflet,
    categoryCustom
    // ProposalSlider
  },
  data() {
    return {
      key: 1
    };
  },
  computed: {
    templateName() {
      if (this.category.navigationTypeId == 1) {
        return "categoryLeaflet";
      } else if (this.category.template) {
        let templateName = camelCase(this.category.template);
        return templateName;
      } else {
        return "categoryMed";
      }
    },
    ...mapProposal({
      header: "header",
      footer: "footer"
    })
  },
  methods: {
    async reload() {
      let slug = split(this.category.slug, "@")[0];
      await this.resetFilters(slug);
      await this.setCategory({ slug: slug, force: true });
      this.key += 1;
    }
  },
  async created() {
    await this.resetFilters(this.category.slug);
  },
  watch: {
    async $route(to) {
      let slug = to.params.pathMatch;
      await this.resetFilters(slug);
      await this.setCategory({ slug });
    }
  }
};
</script>
